<template>
  <div class="publicItems">
    <div class="selectionArea search_box">
      <el-autocomplete
        v-model="accountList.value"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入主公众号"
        :clearable="true"
        @clear="(accountList.value = null),(accountList.address = null),(parameter.master_app_id = null)"
        @select="handleSelect"
      />
      <el-select
        v-model="parameter.master_platform_id"
        placeholder="请选择平台"
        filterable
        :clearable="true"
        @clear="parameter.master_platform_id = null"
      >
        <el-option
          v-for="(item, index) in platformSelectList"
          :key="index"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-button type="primary" style="margin:0" icon="el-icon-search" @click="getDataList('搜索')">搜索</el-button>
      <el-button type="primary" style="margin:0" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button type="success" style="margin:0" icon="el-icon-circle-plus" @click="establish">创建</el-button>
      <el-button type="success" style="margin:0" icon="el-icon-circle-plus" @click="()=> dialogGroup = true">新增投手组</el-button>
      <el-button type="success" style="margin:0" icon="el-icon-circle-plus" @click="()=> dialogPitcher = true">新增投手</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="master_app_id"
          label="主公众号名称"
          align="center"
          min-width="150"
        >
          <template scope="scope">
            <div>{{ scope.row.account_names[0] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="account_names"
          label="公众号名称"
          align="center"
          min-width="150"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.account_names"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="roi_new_user"
          align="center"
          label="新用户ROI"
        >
          <template scope="scope">
            <div>{{ scope.row.roi_new_user }}%</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="cost"
          align="center"
          label="成本"
        />
        <el-table-column
          prop="platform_str"
          align="center"
          label="平台"
        />
        <el-table-column
          prop="novel_title"
          align="center"
          label="小说标题"
        />
        <el-table-column
          prop="group_str"
          align="center"
          label="运营组"
        />
        <el-table-column
          prop="admin_str"
          align="center"
          label="运营者"
        />
        <el-table-column
          prop="launch_group_str"
          align="center"
          label="投手组"
        />
        <el-table-column
          prop="launch_str"
          align="center"
          label="投手"
        />
        <el-table-column
          prop="launch_channel_str"
          align="center"
          label="投放渠道"
        />
        <el-table-column
          prop="out_no_date_str"
          align="center"
          label="出号日期"
        />
        <el-table-column
          prop="s_date_str"
          align="center"
          label="开始时间"
        />
        <el-table-column
          prop="e_date_str"
          align="center"
          label="结束时间"
        />
        <el-table-column
          label="操作"
          align="center"
          min-width="150"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="myDelete(scope.row)">删除</el-button>
            <el-button type="success" size="mini" @click="open(scope.row)">指定更新</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="drawerItem.id ? '修改关系' : '创建关系'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="drawerItem = {}"
    >
      <Details v-if="dialogVisible" ref="details" :drawer-item="drawerItem" @determine="determine" />
    </el-dialog>
    <el-dialog
      title="新增投手组"
      :visible.sync="dialogGroup"
      :close-on-click-modal="false"
      width="40%"
      @closed="(groupName = null)"
    >
      <div class="dialog_box">
        <div class="item1">
          <span class="item_title1">投手组名称</span>
          <el-input v-model="groupName" class="item_input1" />
        </div>
      </div>
      <div class="content_btn">
        <el-button type="primary" @click="addPitcherGroup">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="新增投手"
      :visible.sync="dialogPitcher"
      :close-on-click-modal="false"
      width="40%"
      @closed="(pitcherName = null),(pitcherInfo = {})"
    >
      <div class="dialog_box">
        <div class="item1">
          <span class="item_title1">投手名称</span>
          <el-input v-model="pitcherName" class="item_input1" />
        </div>
      </div>
      <div class="dialog_box" style="margin-top:25px">
        <div class="item1">
          <span class="item_title1">投手组</span>
          <el-autocomplete
            v-model="pitcherInfo.value"
            :fetch-suggestions="groupSearchAsync"
            placeholder="请选择"
            :clearable="true"
            @clear="(pitcherInfo.value = null),(pitcherInfo.address = null)"
            @select="item => pitcherInfo = item"
          />
        </div>
      </div>
      <div class="content_btn">
        <el-button type="primary" @click="addPitcher">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="指定更新"
      :visible.sync="dialogUpdata"
      :close-on-click-modal="false"
      @closed="date = []"
    >
      <div v-if="dialogUpdata" class="item">
        <span>请选择日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="{
            disabledDate: (time) => {
              return time.getTime() < new Date(drawerItem.s_date_str).getTime() - 8.64e7 || time.getTime() > new Date(drawerItem.e_date_str).getTime()
            }
          }"
        />
        <el-button type="primary" class="item_button" @click="theUpdata()">更新</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import {
  getBindingRelationList,
  addBindingRelation,
  modifyBindingRelation,
  deleteBindingRelationp,
  getOfficialAccount,
  getPlatform,
  theUpdata,
  addPitcherGroup,
  addPitcher,
  getsdLaunchList
} from '@/api/platformLabel.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        master_platform_id: null,
        master_app_id: null
      },
      accountList: {}, // 主公众号
      platformSelectList: [], // 平台列表
      dialogVisible: false,
      dialogUpdata: false,
      dialogGroup: false,
      dialogPitcher: false,
      drawerItem: {},
      date: [],
      groupName: null,
      pitcherName: null,
      groupList: [],
      pitcherInfo: {}
    }
  },
  created() {
    this.getDataList()
    this.myGetchannelplatform()
  },

  methods: {

    // 获取数据列表
    async getDataList(value) {
      this.parameter.page = value ? 1 : this.parameter.page
      this.loading = true
      const data = await getBindingRelationList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    // 请求平台列表
    async myGetchannelplatform() {
      const data = await getPlatform()
      this.platformSelectList = data.data.list
    },
    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 指定更新
    async theUpdata() {
      const start = new Date(this.drawerItem.s_date_str).getTime()
      const end = new Date(this.drawerItem.e_date_str).getTime()
      if (start > end) {
        this.$message({
          message: '开始时间不能大于今日',
          type: 'error'
        })
        return
      }
      if (!this.date.length) {
        this.$message({
          message: '请选择开始或者结束日期',
          type: 'error'
        })
        return
      }
      await theUpdata({ master_app_id: this.drawerItem.master_app_id, s_date: this.date[0], e_date: this.date[1] })
      this.$message({
        message: '更新成功',
        type: 'success'
      })
      this.date = []
      this.dialogUpdata = false
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 新增投手
    async addPitcher() {
      if (!this.pitcherInfo.address || !this.pitcherInfo.value) {
        this.$message({
          message: '请选择投手组',
          type: 'error'
        })
        return
      }
      await addPitcher({ name: this.pitcherName, group_id: this.pitcherInfo.address })
      this.$message({
        message: '新增成功',
        type: 'success'
      })
      this.pitcherName = null
      this.pitcherInfo = {}
      this.dialogPitcher = false
    },
    // 新增投手组
    async addPitcherGroup() {
      await addPitcherGroup({ name: this.groupName })
      this.$message({
        message: '新增成功',
        type: 'success'
      })
      this.groupName = null
      this.dialogGroup = false
    },
    // 指定更新
    open(row) {
      this.dialogUpdata = true
      this.drawerItem = row
      this.drawerItem.e_date_str = this.getNowFormatDate(window.Date.now())
      this.date = [row.s_date_str, this.drawerItem.e_date_str]
    },
    // 确定
    async determine(obj) {
      const bool = !!this.drawerItem.id
      bool ? await modifyBindingRelation({ ...{ id: this.drawerItem.id }, ...obj }) : await addBindingRelation(obj)
      this.$message({
        message: bool ? '修改关系成功' : '创建关系成功',
        type: 'success'
      })

      this.drawerItem = {}
      this.dialogVisible = false
      this.reset()
    },

    // 搜索公众号列表
    async querySearchAsync(queryString, cb) {
      const data = await getOfficialAccount({ accountName: queryString || null })
      const news = (data.data.list.map((item) => {
        return {
          value: item.account_name,
          address: item.app_id
        }
      }))
      cb(news)
    },
    // 公众号选择
    handleSelect(item) {
      this.accountList = item
      this.parameter.master_app_id = item.address
    },
    // 搜索投手组列表
    async groupSearchAsync(queryString, cb) {
      const data = await getsdLaunchList({ page: 1, page_size: 10, keywords: queryString || null })
      const news = (data.data.list.map((item) => {
        return {
          value: item.name,
          address: item.id
        }
      }))
      cb(news)
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        master_platform_id: null,
        master_app_id: null
      }
      this.accountList = {}
      this.getDataList()
    },

    // 删除
    async myDelete(row) {
      await deleteBindingRelationp(row.id)
      this.getDataList()
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    },

    // 创建按钮的点击事件的处理函数
    establish() {
      this.drawerItem = {}
      this.dialogVisible = true
    },
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }
  }
}
</script>

<style scoped lang="less">
.dialog_box{
   .item1{
     display: flex;
     flex-direction:row ;
     align-items: center;
    .item_title1{
       display: inline-block;
       width: 80px;
    }
    .item_input1{
       width: 200px
    }
   }
}
.content_btn{
display: flex;
margin-top: 30px;
justify-content: flex-end;
}
.publicItems{
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;

}

.publicItems .selectionArea{
    margin-bottom: 20px;
}
.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
.item{
    display: flex;
    flex-direction: column;
}
.item>span{
  font-size: 1rem;
  margin-bottom: 15px;
}
  .item_button{
    margin-left: auto;
  }
  .el-range-editor--medium.el-input__inner{
    width:65vw;
  }
</style>

<style>
</style>
